import React, {useCallback, useState} from 'react';
import ReactDOM from 'react-dom';

type RefNode = React.Component | HTMLElement | null | undefined;

/**
 * Hook which finds the CId of the parent modal of the referenced node.
 * This is particularly useful to manage popovers inside of modals.
 *
 * Usage:
 * function MyPopoverComponent() {
 *   const [parentModalCid, popoverRef] = useParentModalCid();
 *
 *   return (
 *     <Popover
 *         ref={popoverRef}
 *         container={parentModalCid != null ? `[data-modal-cid=${parentModalCid}]` : 'body'}
 *     >
 *         {props.children}
 *      </Popover>
 *   );
 * }
 */
export default function useParentModalCid(): [string | undefined, (node: RefNode) => void] {
  const [parentModalCid, setParentModalCid] = useState<string>();
  const nodeRef = useCallback((node: RefNode) => {
    const currentNode = ReactDOM.findDOMNode(node);
    if (currentNode != null) {
      // The ModalContainer has the CId of the currently open modal stored in the data-modal-cid attribute
      const modalContainer = $(currentNode).closest('[data-modal-cid]');
      if (modalContainer) {
        setParentModalCid(modalContainer.attr('data-modal-cid'));
      }
    }
  }, []);
  return [parentModalCid, nodeRef];
}
